<script setup>
import Button from '@/components/foundation/Button.vue';
import { OLD_VISION_AI_RESOURCE_CENTER_URL } from '@/components/VisionAi/constants';
</script>

<template>
  <div>
    <h4 class="!text-[1.375rem] !normal-case">
      Vision AI Summaries are only available for Dashboards, Community, and Social Listening
    </h4>
    <p class="!py-6 !text-sm">
      Spend less time analyzing data and get report-<br />ready insights with Vision AI Summaries.
    </p>

    <div class="!flex">
      <Button dark-blue :href="OLD_VISION_AI_RESOURCE_CENTER_URL">Learn More</Button>
    </div>
  </div>
</template>
